import React, { useState, useEffect } from "react";
import md5 from "md5";

import queryString from "../../utils/queryString";

export default props => {
  const { user, size, defaultImg, ...rest } = props;
  const [gravatarUrl, setGravatarUrl] = useState();
  const baseGravatar = '//gravatar.com/avatar/'
  useEffect(() => {
    if (!user.pictureUrl && !gravatarUrl) {
      if (typeof user.email === 'string') {
        const hash = md5(user.email.trim().toLowerCase(), { encoding: "binary" });
        const query = queryString({
          s: size || 100,
          r: 'g',
          d: defaultImg || 'retro',
        })
        setGravatarUrl(`${baseGravatar}${hash}${query}`)
      }
    }
  });
  return (
    <img
      src={user.pictureUrl || gravatarUrl}
      alt={user.email}
      {...rest}
    />
  )
}